import React, { FC } from 'react';
import { BadgeProps } from 'antd';

import { Badge as StyledBadge } from './styled';

export const Badge: FC<BadgeProps> = props => <StyledBadge {...props} />;

Badge.defaultProps = {
  overflowCount: 999,
};
